import React from "react";
import { useTranslation } from "react-i18next";
import SeoHead from "../seo/SeoHead";
import ServicePage, { RelatedServices, ServiceChecklist, ServiceCta, ServiceFaq, ServiceHero } from "./ServicePageLayout";
import RoadSimuImg from "../../assets/road-simu.png";

const RoadSimulationTesting = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';
    const lang = i18n.language === 'en' ? 'en' : 'ar';
    const faq = t('roadSimPage.faq', { returnObjects: true });

    return (
        <ServicePage isRTL={isRTL}>
            <SeoHead
                path="services/road-simulation-testing"
                title={t('roadSimPage.metaTitle')}
                description={t('roadSimPage.metaDescription')}
                keywords={t('roadSimPage.keywords')}
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'FAQPage',
                    mainEntity: faq.map(({ q, a }) => ({
                        '@type': 'Question',
                        name: q,
                        acceptedAnswer: { '@type': 'Answer', text: a },
                    })),
                }}
            />

            <ServiceHero
                eyebrow={t('roadSimPage.eyebrow')}
                title={t('roadSimPage.title')}
                intro={t('roadSimPage.description').replace(/<\/?strong>/g, '')}
                image={RoadSimuImg}
                imageAlt={t('roadSimPage.imageAlt')}
                ctaLabel={t('roadSimPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز اختبار محاكاة الطريق.' : 'Hi, I would like to book a road simulation test.'}
            />

            <ServiceChecklist title={t('roadSimPage.coverTitle')} points={t('roadSimPage.coverPoints', { returnObjects: true })} />
            <ServiceFaq title={t('roadSimPage.faqTitle')} items={faq} />
            <RelatedServices title={t('roadSimPage.related.title')} items={t('roadSimPage.related.items', { returnObjects: true })} lang={lang} />

            <ServiceCta
                eyebrow={t('roadSimPage.eyebrow')}
                title={t('roadSimPage.title')}
                body={t('roadSimPage.metaDescription')}
                ctaLabel={t('roadSimPage.ctaLabel')}
                ctaMessage={isRTL ? 'مرحباً، أرغب في حجز اختبار محاكاة الطريق.' : 'Hi, I would like to book a road simulation test.'}
            />
        </ServicePage>
    );
}

export default RoadSimulationTesting;
